import { Box, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const stats = [
  { value: 10000, label: "Happy Users", suffix: "+" },
  { value: 95, label: "Success Rate", suffix: "%" },
  { value: 5000, label: "Matches Made", suffix: "+" },
  { value: 24, label: "Cities", suffix: "+" },
];

const AnimatedCounter = ({ end, suffix = "" }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const duration = 3000;
    const increment = end / (duration / 16);
    let start = 0;
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [end]);
  return <span>{count.toLocaleString()}{suffix}</span>;
};

const StatCard = ({ stat, index }) => (
  <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.1 }}>
    <Box
      sx={{
        textAlign: "center",
        p: { xs: 2, md: 4 },
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        height: "100%",
      }}
    >
      <Typography
        variant="h2"
        component="div"
        sx={{
          fontWeight: 800,
          mb: 1,
          color: "#fff",
          fontSize: { xs: "1.75rem", sm: "2.25rem", md: "3rem", lg: "3.5rem" },
        }}
      >
        <AnimatedCounter end={stat.value} suffix={stat.suffix} />
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 600, color: "rgba(255,255,255,0.8)", fontSize: { xs: "1rem", md: "1.25rem" } }}>
        {stat.label}
      </Typography>
    </Box>
  </motion.div>
);

const StatsSection = () => (
  <Box sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 4 }, backgroundColor: "#fff" }}>
    <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
      <Grid container spacing={{ xs: 2, md: 4 }}>
        {stats.map((stat, index) => (
          <Grid item xs={6} sm={3} key={index}>
            <StatCard stat={stat} index={index} />
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default StatsSection;